import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {ARTIFACT_VERSION_PATH} from '../artifacts/artifactPaths';
import {type RouteData} from '../types';
import {REGISTRY_PATHS} from './registryPaths';

export const REGISTRY_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // RegistriesRouter handles tracking since there are nested routes
    },
    exact: true,
    isPrivateRoute: true,
    path: REGISTRY_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/Registries/RegistriesRouter')
    ).Component,
  },
  {
    path: `${ARTIFACT_VERSION_PATH}/graph`,
    redirect: `${ARTIFACT_VERSION_PATH}/lineage`,
  },
  {
    path: '/models',
    redirect: '/registry/model',
  },
];
